import React from 'react';

import { CardListFilterMenu } from '@vlabs/monokit/entities/cards/filters';
import { CardsFiltersProvider } from '@vlabs/monokit/entities/cards/filters/useCardsFilters';
import type { GetCardsParams } from '@vlabs/api/point-api/model';
import { FilterMenuProvider } from '@vlabs/monokit/shared/ui/filter-menu';
import { Page, PageContent } from '@vlabs/monokit/shared/ui/page';
import { PageFilters } from '@vlabs/monokit/shared/ui/page/PageFilters';
import { DEFAULT_PAGE_SIZE } from '@vlabs/uikit/constants';

import { CardListPageHeader } from './card-list-page-header';
import { CardListViewer } from './card-list-viewer';

const defaultCardListFilters: GetCardsParams = {
  page: 1,
  page_size: DEFAULT_PAGE_SIZE,
  sort: 'create_time',
  order: 'desc',
};

interface CardListPageProps {
  title?: string;
  titleItems?: React.ReactNode | React.ReactNode[];
}

export function CardListPage({
  title = undefined,
  titleItems = undefined,
}: CardListPageProps): React.JSX.Element {
  return (
    <Page>
      <CardsFiltersProvider initialData={defaultCardListFilters}>
        <FilterMenuProvider>
          <PageContent>
            <CardListPageHeader
              title={title}
              titleItems={titleItems}
            />
            <CardListViewer />
          </PageContent>

          <PageFilters>
            <CardListFilterMenu />
          </PageFilters>
        </FilterMenuProvider>
      </CardsFiltersProvider>
    </Page>
  );
}
